/* Speediance Gym Nano - product page behaviour. No dependencies. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal on scroll ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.nano-reveal:not([data-revealed])');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-in');
        el.setAttribute('data-revealed', '1');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          e.target.setAttribute('data-revealed', '1');
          io.unobserve(e.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );
    els.forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i % 6, 5) * 60 + 'ms';
      io.observe(el);
    });
  }

  /* ---------- sticky product bar ---------- */
  function initBar(root) {
    (root || document).querySelectorAll('[data-nano-bar]').forEach(function (bar) {
      if (bar.dataset.bound) return;
      bar.dataset.bound = '1';
      var sentinel = document.getElementById(bar.dataset.nanoBar);
      if (!sentinel || !('IntersectionObserver' in window)) {
        bar.classList.add('is-pinned');
        return;
      }
      new IntersectionObserver(
        function (entries) {
          bar.classList.toggle('is-pinned', !entries[0].isIntersecting);
        },
        { threshold: 0 }
      ).observe(sentinel);
    });
  }

  /* ---------- resistance mode explorer ---------- */
  function initModes(root) {
    (root || document).querySelectorAll('[data-nano-modes]').forEach(function (wrap) {
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(wrap.querySelectorAll('[role="tabpanel"]'));
      if (!tabs.length) return;

      function select(idx, focus) {
        tabs.forEach(function (t, i) {
          t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
          t.setAttribute('tabindex', i === idx ? '0' : '-1');
        });
        panels.forEach(function (p, i) {
          if (i === idx) {
            p.removeAttribute('hidden');
            // restart the draw animation
            var line = p.querySelector('.nano-curve-line');
            if (line && !reduce) {
              line.style.animation = 'none';
              void line.offsetWidth;
              line.style.animation = '';
            }
          } else {
            p.setAttribute('hidden', '');
          }
        });
        if (focus) tabs[idx].focus();
        var t = tabs[idx];
        if (t.parentElement && t.parentElement.scrollWidth > t.parentElement.clientWidth) {
          t.parentElement.scrollTo({
            left: t.offsetLeft - 16,
            behavior: reduce ? 'auto' : 'smooth'
          });
        }
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          select(i, false);
        });
        t.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          select((i + d + tabs.length) % tabs.length, true);
        });
      });
      select(0, false);
    });
  }

  /* ---------- gauges ---------- */
  function initGauges(root) {
    var gs = (root || document).querySelectorAll('[data-nano-gauge]:not([data-bound])');
    if (!gs.length) return;
    function fill(el) {
      var arc = el.querySelector('.nano-gauge__val');
      if (!arc) return;
      var len = arc.getTotalLength ? arc.getTotalLength() : 240;
      var pct = Math.max(0, Math.min(1, parseFloat(el.dataset.nanoGauge) || 0));
      arc.style.strokeDasharray = len * pct + ' ' + len * 2;
    }
    if (reduce || !('IntersectionObserver' in window)) {
      gs.forEach(function (el) {
        el.dataset.bound = '1';
        fill(el);
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          fill(e.target);
          io.unobserve(e.target);
        });
      },
      { threshold: 0.4 }
    );
    gs.forEach(function (el) {
      el.dataset.bound = '1';
      io.observe(el);
    });
  }

  /* ---------- reels (click to play, one at a time) ---------- */
  function initReels(root) {
    (root || document).querySelectorAll('[data-nano-reels]:not([data-bound])').forEach(function (track) {
      track.dataset.bound = '1';

      track.querySelectorAll('.nano-reel').forEach(function (reel) {
        var video = reel.querySelector('video');
        var btn = reel.querySelector('.nano-reel__play');
        if (!video || !btn) return;
        btn.addEventListener('click', function () {
          if (!video.paused) {
            video.pause();
            reel.classList.remove('is-playing');
            return;
          }
          document.querySelectorAll('.nano-reel.is-playing').forEach(function (o) {
            var v = o.querySelector('video');
            if (v) v.pause();
            o.classList.remove('is-playing');
          });
          video.setAttribute('controls', '');
          video.play();
          reel.classList.add('is-playing');
        });
        video.addEventListener('pause', function () {
          reel.classList.remove('is-playing');
        });
        video.addEventListener('ended', function () {
          reel.classList.remove('is-playing');
          video.currentTime = 0;
        });
      });

      var nav = track.parentElement ? track.parentElement.querySelector('[data-nano-reels-nav]') : null;
      if (!nav) return;
      nav.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = track.clientWidth * 0.8 * (b.dataset.dir === 'prev' ? -1 : 1);
          track.scrollBy({ left: step, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });
  }

  /* ---------- gallery lightbox ---------- */
  var lb, lbImg, lbList, lbIdx;
  function ensureLightbox() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'nano-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML =
      '<button class="nano-lightbox__close" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<button class="nano-lightbox__prev" aria-label="Previous"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button class="nano-lightbox__next" aria-label="Next"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '<img alt="">';
    document.body.appendChild(lb);
    lbImg = lb.querySelector('img');
    function close() {
      lb.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }
    function go(d) {
      if (!lbList || !lbList.length) return;
      lbIdx = (lbIdx + d + lbList.length) % lbList.length;
      lbImg.src = lbList[lbIdx].full;
      lbImg.alt = lbList[lbIdx].alt || '';
    }
    lb.querySelector('.nano-lightbox__close').addEventListener('click', close);
    lb.querySelector('.nano-lightbox__prev').addEventListener('click', function (e) {
      e.stopPropagation();
      go(-1);
    });
    lb.querySelector('.nano-lightbox__next').addEventListener('click', function (e) {
      e.stopPropagation();
      go(1);
    });
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target === lbImg) close();
    });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') go(-1);
      if (e.key === 'ArrowRight') go(1);
    });
    return lb;
  }

  function initGallery(root) {
    (root || document).querySelectorAll('[data-nano-gallery]:not([data-bound])').forEach(function (g) {
      g.dataset.bound = '1';
      var btns = Array.prototype.slice.call(g.querySelectorAll('button[data-full]'));
      var list = btns.map(function (b) {
        return { full: b.dataset.full, alt: b.dataset.alt || '' };
      });
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () {
          ensureLightbox();
          lbList = list;
          lbIdx = i;
          lbImg.src = list[i].full;
          lbImg.alt = list[i].alt;
          lb.classList.add('is-open');
          document.documentElement.style.overflow = 'hidden';
        });
      });
    });
  }

  /* ---------- hero video: lazy + pause offscreen ---------- */
  function initHeroVideo(root) {
    (root || document).querySelectorAll('video[data-nano-autoplay]:not([data-bound])').forEach(function (v) {
      v.dataset.bound = '1';
      if (reduce) return;
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      var src = (mobile && v.dataset.srcMobile) || v.dataset.src || v.currentSrc || v.src;
      var loaded = false;
      var load = function () {
        if (loaded || !src) return;
        loaded = true;
        v.src = src;
        v.load();
      };
      var play = function () {
        load();
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            entries[0].isIntersecting ? play() : v.pause();
          },
          { threshold: 0.05 }
        ).observe(v);
      } else {
        play();
      }
    });
  }

  /* ---------- init ---------- */
  function init(root) {
    initReveal(root);
    initBar(root);
    initModes(root);
    initGauges(root);
    initReels(root);
    initGallery(root);
    initHeroVideo(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) {
    init(e.target);
  });
})();
